/* eslint-disable react/destructuring-assignment */
import { addReactError } from '@datadog/browser-rum-react';
import type { ErrorInfo, ReactNode } from 'react';
import { Component } from 'react';
import { trackAppCrash } from '../analytics/tracking/helpers';

export interface ErrorBoundaryProps {
  readonly children: ReactNode;
  readonly fallback: ReactNode;
}

interface State {
  readonly hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, State> {
  public state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    addReactError(error, errorInfo);
    trackAppCrash(error);
    // eslint-disable-next-line no-console
    console.error('Uncaught error:', error, errorInfo);
  }

  render(): JSX.Element | ReactNode {
    if (this.state.hasError) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}
